import React from "react";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBBtn,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBadge,
} from "mdb-react-ui-kit";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";

/**
 * Modal para confirmar un movimiento de presupuesto (PLANIFICADO → CONFIRMADO).
 *
 * Props:
 *  - show:              boolean
 *  - transaccion:       objeto { IDTransaccion, concepto, cantidad, IDCategoriaFK }
 *  - cuentasPersonales: array de cuentas disponibles como destino (tipo != BUDGET)
 *  - onClose():         callback al cerrar
 *  - onConfirmado():    callback após confirmar con éxito
 *  - onLoading(bool):   callback para spinner
 */
export class ConfirmarPresupuestoModal extends React.Component {
  constructor(props) {
    super(props);

    const today = new Date().toISOString().split("T")[0];

    this.state = {
      fechaCargo: today,
      idCuentaDestino: "",
      errorMsg: "",
    };
  }

  closeModal = () => {
    this.props.onClose();
  };

  formatCurrency(value) {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
    }).format(value);
  }

  async doConfirmar() {
    const { transaccion } = this.props;
    const { fechaCargo, idCuentaDestino } = this.state;

    if (!fechaCargo) {
      this.setState({ errorMsg: "La fecha de cargo es obligatoria." });
      return;
    }
    if (!idCuentaDestino) {
      this.setState({ errorMsg: "Debes seleccionar una cuenta destino." });
      return;
    }

    this.setState({ errorMsg: "" });
    this.props.onLoading(true);

    const requestOptions = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        idTransaccionPresupuesto: transaccion.IDTransaccion,
        fechaCargo,
        idCuentaDestino: parseInt(idCuentaDestino, 10),
      }),
    };

    await doFetch("CCON", "confirmarPresupuesto", requestOptions)
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.props.onConfirmado();
        } else {
          this.setState({ errorMsg: data.MESSAGE || "Error al confirmar el presupuesto." });
        }
      })
      .catch(() => {
        this.setState({ errorMsg: "Error de conexión al confirmar." });
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  render() {
    const { show, transaccion, cuentasPersonales } = this.props;
    const { fechaCargo, idCuentaDestino, errorMsg } = this.state;

    if (!transaccion) return null;

    // Filtrar cuentas que no sean BUDGET
    const cuentasDestino = (cuentasPersonales || []).filter(
      (c) => c.tipo !== "BUDGET"
    );

    return (
      <MDBModal show={show} onHide={this.closeModal} tabIndex="-1">
        <MDBModalDialog size="md">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Confirmar presupuesto</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={this.closeModal} />
            </MDBModalHeader>
            <MDBModalBody>
              <MDBContainer>
                {/* Resumen del movimiento presupuestario */}
                <div className="p-3 mb-3 border rounded bg-light">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <span className="fw-semibold">{transaccion.concepto}</span>
                    <MDBBadge color="primary" pill>
                      {this.formatCurrency(transaccion.cantidad)}
                    </MDBBadge>
                  </div>
                  {transaccion.IDCategoriaFK && transaccion.IDCategoriaFK.nombre && (
                    <small className="text-muted">
                      Categoría: {transaccion.IDCategoriaFK.nombre}
                    </small>
                  )}
                </div>

                <MDBRow className="mb-3">
                  <MDBCol size="12">
                    <MDBInput
                      type="date"
                      id="fechaCargo"
                      label="Fecha real de cargo"
                      value={fechaCargo}
                      onChange={(e) => this.setState({ fechaCargo: e.target.value })}
                    />
                  </MDBCol>
                </MDBRow>

                <MDBRow className="mb-3">
                  <MDBCol size="12">
                    <label className="form-label">Cuenta destino</label>
                    <select
                      className="form-select"
                      value={idCuentaDestino}
                      onChange={(e) => this.setState({ idCuentaDestino: e.target.value })}
                    >
                      <option value="">— Selecciona cuenta —</option>
                      {cuentasDestino.map((c) => (
                        <option key={c.IDCuenta} value={c.IDCuenta}>
                          {c.nombre}
                          {c.tipo === "SHARED_EXPENSE" ? " (Compartida)" : ""}
                        </option>
                      ))}
                    </select>
                  </MDBCol>
                </MDBRow>

                {errorMsg && (
                  <div className="alert alert-danger py-2">{errorMsg}</div>
                )}

                <div className="d-flex gap-2 justify-content-end">
                  <MDBBtn color="secondary" onClick={this.closeModal}>
                    Cancelar
                  </MDBBtn>
                  <MDBBtn color="success" onClick={() => this.doConfirmar()}>
                    Confirmar presupuesto
                  </MDBBtn>
                </div>
              </MDBContainer>
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    );
  }
}
